import axios from "axios";
import { DailyMealRecord } from "./dailyAvailability";

export interface DayPlan {
  date: string;
  kitchenId: string;
  swapSetSerial: number;
  swapSetActive: boolean;
  orderCount: number;
  isProjected: boolean;
  rows: Array<{ id: string; kind: string; name: string; origins: string[]; demand: number;
    instantMeals: Array<{ id: string; name: string; scheduled: boolean; isAvailable: boolean; stock: number | null; stockMode: string; sharedStockGroupId?: string }> }>;
  catalogue: Array<{ id: string; name: string }>;
  scheduledMeals: DailyMealRecord[];
}
const config = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("adminToken")}` } });
const base = `${process.env.REACT_APP_API_URL || ""}/api/admin/daily-availability`;
export const instantDayPlanningApi = {
  getPlan: async (date: string, kitchenId: string): Promise<DayPlan> => {
    const response = await axios.get(`${base}/planning`, { ...config(), params: { date, kitchenId } });
    return response.data;
  },
  saveRule: async (data: { date: string; kitchenId: string; mealId: string; stockMode: string; quantity: number }) => {
    const response = await axios.post(`${base}/date-rule`, data, config());
    return response.data;
  },
};
